module.exports = "/static/assets/eb67f5dfdeb1ebfa3f54e5c026de9cd9.gif";